import { useSession } from "./SessionProvider.tsx";
import { useIsProtectActive } from "./useIsProtectActive.ts";

// /bff/tenants reads consented without an active subscription or Protect access, while the tenant data endpoints 403.
// Callers outside the gates, such as the header widget, check this so they send no request that 403s.
export function useHasActiveProtectAccess(): boolean {
    const session = useSession();
    const isProtectActive = useIsProtectActive();

    return isProtectActive && session.products?.protect.hasAccess !== false;
}
